import React from "react";

function SubAllowableContent () {
    return(
        <div className="container">
            <div className="row EmpContentHeader styleAllowable">
                {/* <div className="col-1">
                    <span>SL No.</span>
                </div> */}
                {/* <div className="col-1 DCenter">
                    <span>Designation</span>
                </div> */}
                <div className="col-2">
                    <span>P Resources</span>
                </div>
                {/* <div className="col-2 DCenter">
                    <span>P Total Hrs</span>
                </div> */}
                <div className="col-2 DCenter">
                    <span>Allowable Resources</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Allowable Total Hrs</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Actual Total Hrs</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Actual Total Cost</span>
                </div>
                <div className="col-1 DCenter">
                    <span>SPI</span>
                </div>
                <div className="col-1 DEnd">
                    <span>CPI</span>
                </div>
            </div>
        </div>
    )
};

export default SubAllowableContent ;